import styled from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'

const Label = styled.p`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey40};
  margin: 0;
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 14px;
    line-height: 20px;
  }
`

type LabeledProps = { children: string }

const LabeledValue: React.FC<LabeledProps> = ({ children }) => <Label>{children}</Label>

export default LabeledValue
